import React, { useEffect, useState } from 'react'
import TapHelper from '../../../../services/TapHelper'
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import DateService from '../../../../services/DateService'
import { useDispatch, useSelector } from 'react-redux';
import { apiRunWithAxios } from './APIRunWithAxios';
import Loader from '../../../../components/ui/Loader/Loader';
import { authLoginAndGetJWTToken } from '../../../../store/actions/OmniComm/OmniCommAuthAction';

function StatisticReport({formData}) {

    const dispatch          =   useDispatch();
    const { data }          =   useSelector(state => state.omniAuthLoginReducer);    

    const [movementOperation, setMovementOperation] =   useState({});
    const [fuelData, setFuelData]           =   useState({});
    const [meterReading, setMeterReading]   =   useState({})
    const [loading, setLoading]             =   useState(false)


    useEffect(() => {
        if (data?.jwt) {
            getStatisticData()
        }
    }, [formData, data])
    
   const getStatisticData          =   async () => {
        const startOfDay    =   Math.floor(new Date(formData.date_range_start + " 00:00:00").getTime() / 1000);
        const endOfDay      =   Math.floor(new Date(formData.date_range_end + " 23:59:59").getTime() / 1000);
        
        if(formData.asset_id && startOfDay && endOfDay) {
            const params        =   {
                versionNumber       :   'v1',
                timeBegin           :   startOfDay,
                timeEnd             :   endOfDay,
                dataGroups          :   '[mw, fuel, mnt]',
                vehicles            :   `[${formData.asset_id}]`
            }
            setLoading(pre => !pre);
            setMovementOperation({});
            setFuelData({});
            try {
                let response        =   await apiRunWithAxios("https://online.omnicomm.in/ls/api/v1/reports/statistics", "GET", data?.jwt, params);
                setLoading(false);    
                const results       =   response.data.data;
                setMovementOperation(results.totalMw);
                setFuelData(results?.vehicleDataList[0]['fuel']);
            } catch (error) {
                setLoading(false);
                if(error?.response?.status === 401 && error?.response?.data?.error === "Unauthorized") {
                    swal({
                        title: "Refresh",
                        text: "Please refresh again for fetch statistic data.",
                        icon: "warning",
                        // dangerMode: true,
                        buttons: ["Cancel", "Refresh"],
                    }).then(willDelete => {
                        if (willDelete) {
                            dispatch(authLoginAndGetJWTToken());
                        }
                    });
                }
            } finally {
                setLoading(false);
            }
        }else {
            toast.error('Select asset & time period both are required, for statistic report.', { position: toast.POSITION.TOP_RIGHT });
        }
    }



    return (
        <>
            {
                loading
                    ? <Loader/>
                    :
                    <>
                        <div className="tab_content_wrapper mt-2 my-1">
                            <span className="content_heading">Movement & operation</span>
                        </div>
                        <div className="table-responsive px-3">
                            <table className="table table-hover table-bordered">
                                <thead className="table-secondary">
                                    <tr>
                                        <th className='text-center' style={{ width: "5%" }}>#</th>
                                        <th style={{ width: "35%" }}>Name</th>
                                        <th style={{ width: "20%" }}>Unit</th>
                                        <th style={{ width: "15%" }}>Values</th>
                                        <th style={{ width: "25%" }}>-</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='text-center'>a</td>
                                        <td className="fs14 fw-normal">Total Km</td>
                                        <td className='fs14 fw-normal'>Km</td>
                                        <td className="fs14 fw-normal">{movementOperation?.totalMileage ? TapHelper.numberFormatter(movementOperation.totalMileage) : '-'}</td>
                                        <td className='fs14 fw-normal'></td>
                                    </tr>

                                    <tr>
                                        <td className='text-center'>b</td>
                                        <td className="fs14 fw-normal">Max speed</td>
                                        <td className='fs14 fw-normal'>Km/hr</td>
                                        <td className="fs14 fw-normal">{movementOperation?.maxSpeed ? TapHelper.numberFormatter(movementOperation.maxSpeed) : '-'}</td>
                                        <td className='fs14 fw-normal'></td>
                                    </tr>

                                    <tr>
                                        <td className='text-center align-middle ' rowSpan="2">c</td>
                                        <td className="fs14 fw-normal align-middle " rowSpan="2" >Total Runnings Hrs</td>
                                        <td className='fs14 fw-normal align-middle ' rowSpan="2">hh:mm:ss</td>
                                        <td className="fs14 fw-normal align-middle " rowSpan="2">{DateService.formatSecondsToTime(movementOperation?.totalWorked) || '-'}</td>
                                        <td className='fs14 fw-normal'>
                                            Motionless :{DateService.formatSecondsToTime(movementOperation?.totalWorkedNoMovementTime) || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='fs14 fw-normal'>
                                            In Motion :  {DateService.formatSecondsToTime(movementOperation?.totalWorkedOnMove) || '-'}
                                        </td>
                                    </tr>


                                    <tr>
                                        <td className='text-center align-middle ' rowSpan="2">d</td>
                                        <td className="fs14 fw-normal align-middle " rowSpan="2">Total Runnings %</td>
                                        <td className='fs14 fw-normal align-middle ' rowSpan="2">% </td>
                                        <td className='fs14 fw-normal align-middle ' rowSpan="2">
                                            {movementOperation?.totalWorkedPercent ? TapHelper.numberFormatter(movementOperation.totalWorkedPercent) : '-'}
                                        </td>
                                        <td className='fs14 fw-normal'>
                                            Motionless : {movementOperation?.totalWorkedNoMovementPercent ? TapHelper.numberFormatter(movementOperation.totalWorkedNoMovementPercent) : '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='fs14 fw-normal'>
                                            In Motion :     {movementOperation?.totalWorkedOnMovePercent ? TapHelper.numberFormatter(movementOperation.totalWorkedOnMovePercent) : '-'}
                                        </td>
                                    </tr>


                                    <tr>
                                        <td className='text-center'>e</td>
                                        <td className="fs14 fw-normal">Time with the engine Switched off</td>
                                        <td className='fs14 fw-normal'>hour:min:sec</td>
                                        <td className="fs14 fw-normal">{DateService.formatSecondsToTime(movementOperation?.totalLayUpTime) || '-'}</td>
                                        <td className='fs14 fw-normal'></td>
                                    </tr>

                                    {/* Row 6: Percentage */}
                                    <tr>
                                        <td className='text-center'>f</td>
                                        <td className="fs14 fw-normal">Time with the engine Switched off</td>
                                        <td className='fs14 fw-normal'>% </td>
                                        <td className='fs14 fw-normal'>{movementOperation?.totalLayUpTimePercent ? TapHelper.numberFormatter(movementOperation.totalLayUpTimePercent) : '-'}</td>
                                        <td className='fs14 fw-normal'></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                       


            <div className="tab_content_wrapper mt-3 my-1">
                <span className="content_heading">Fuel (main tank)</span>
            </div>
            <div className="table-responsive px-2 pb-5">
                <table className="table table-hover table-bordered my-1">
                    <thead className="table-secondary">
                        <tr>
                            <th className='text-center' style={{ width: "5%" }}>#</th>
                            <th style={{ width: "35%" }}>Name</th>
                            <th style={{ width: "20%" }}>Unit</th>
                            <th style={{ width: "20%" }}>Values</th>
                            <th style={{ width: "20%" }}>-</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='text-center'>a</td>
                            <td className="fs14 fw-normal" >Initial volume</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.startVolume ? fuelData?.startVolume/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>b</td>
                            <td className="fs14 fw-normal" >Refueling volume</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.refuelling ? fuelData.refuelling/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>c</td>
                            <td className="fs14 fw-normal" >Draining volume</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.draining ? fuelData.draining/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>d</td>
                            <td className="fs14 fw-normal" >Final volume</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.endVolume ? fuelData.endVolume/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>e</td>
                            <td className="fs14 fw-normal" >Actual consumption</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal" >{fuelData?.fuelConsumption ? fuelData.fuelConsumption/10 : ''}</td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        <tr>
                            <td className='text-center'>f</td>
                            <td className="fs14 fw-normal" >Actual mileage per 1 l</td>
                            <td className='fs14 fw-normal'>km</td>
                            <td className="fs14 fw-normal">
                                {(fuelData.fuelConsumption/10) !== 0 && movementOperation?.totalMileage ? TapHelper.numberFormatter(((movementOperation.totalMileage) / (fuelData.fuelConsumption/10))) : ''}
                            </td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                        {/* <tr>
                            <td className='text-center'>g</td>
                            <td className="fs14 fw-normal" >Actual fuel consumption per 1 hour of engine operation</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal">
                                {fuelData?.fuelConsMH ? TapHelper.numberFormatter((fuelData.fuelConsMH/10), 1) : ''}
                            </td>
                            <td className='fs14 fw-normal'></td>
                        </tr> */}
                        <tr>
                            <td className='text-center'>g</td>
                            <td className="fs14 fw-normal" >Actual fuel consumption per engine hour</td>
                            <td className='fs14 fw-normal'>L</td>
                            <td className="fs14 fw-normal">
                                {fuelData?.fuelConsPerMotorhour ? TapHelper.numberFormatter((fuelData.fuelConsPerMotorhour/10), 1) : ''}
                            </td>
                            <td className='fs14 fw-normal'></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    }
    </>
  )
}

export default StatisticReport